import { FC } from 'react'

import { Dialog } from '@syconium/little-miss-figgy/dist/components'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { SizeChartModalContent } from '../../../../../../brunswick/components/size-chart/SizeChartModal/SizeChartModalContent'
import { trackEvent } from '../../../../../../lib/analytics'
import { SizeChart as SizeChartType } from '../../../../../../types/graphql'

import * as Styles from './styles'

interface Props {
  category: string
  sizeChart?: SizeChartType
  hideTitle?: boolean
}

export const SizeChart: FC<Props> = ({ category, sizeChart }) => {
  const {
    sizesSection: { sizeChartCTA, sizeChart: sizeChartText },
  } = useTranslation()

  return (
    <Dialog.Provider>
      <Dialog.Disclosure
        render={
          <Styles.SizeChartButton
            aria-label={sizeChartCTA}
            {...trackEvent({ category, action: 'open size chart' })}
          >
            {sizeChartCTA}
          </Styles.SizeChartButton>
        }
      />
      <Styles.DialogModal
        header={
          <Dialog.Header
            title={<Styles.ModalHeader>{sizeChartText.modalHeadline}</Styles.ModalHeader>}
            dismiss={<Dialog.Dismiss aria-label='Close modal' />}
          />
        }
        footer={null}
        fullscreenMobile
        content={<Styles.ModalContent />}
      >
        <SizeChartModalContent sizeChart={sizeChart} showHeader={false} />
      </Styles.DialogModal>
    </Dialog.Provider>
  )
}
